/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown>, cost: NonNullable<unknown> }} Agent_Plugin_OverageInputs */



/**
* | output |
* | --- |
* | "Overage this period: {credits} credits (${cost})" |
*
* @param {Agent_Plugin_OverageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_overage = /** @type {((inputs: Agent_Plugin_OverageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_OverageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dépassement pour cette période : ${i?.credits} crédits ($${i?.cost})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Überschreitung dieses Zeitraums: ${i?.credits} Gutschriften ($${i?.cost})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Superamento del periodo: ${i?.credits} crediti ($${i?.cost})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Перерасход за этот период: ${i?.credits} кредитов ($${i?.cost})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exceso de este período: ${i?.credits} créditos ($${i?.cost})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`本期超额收益：${i?.credits} 积分（$${i?.cost}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`今期の超過額：${i?.credits}クレジット（$${i?.cost}）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस अवधि में अतिरिक्त राशि: ${i?.credits} क्रेडिट ($${i?.cost})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Excedente neste período: ${i?.credits} créditos ($${i?.cost})`)
	return /** @type {LocalizedString} */ (`Overage this period: ${i?.credits} credits ($${i?.cost})`)
});